import { LOCAL_STORAGE_KEYS } from "../constants";
import { IChannel, ICommunity } from "../models/channel";

const useLocalStorage = () => {
  const configures = localStorage.getItem(LOCAL_STORAGE_KEYS.CONFIGURE);
  const screenSaver = localStorage.getItem(LOCAL_STORAGE_KEYS.SCREEN_SAVER);
  const myPlace = localStorage.getItem(LOCAL_STORAGE_KEYS.MY_PLACE);
  const screenSaverTimeout = localStorage.getItem(
    LOCAL_STORAGE_KEYS.SCREEN_SAVER_TIMEOUT
  );
  const radius = localStorage.getItem(LOCAL_STORAGE_KEYS.RADIUS);

  const storeConfigures = (conf: ICommunity) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.CONFIGURE, JSON.stringify(conf));
  };

  const storeScreenSaver = (conf: IChannel) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.SCREEN_SAVER, JSON.stringify(conf));
  };

  const storeMyPlace = (conf: IChannel) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.MY_PLACE, JSON.stringify(conf));
  };

  const storeLocalStorage = (key: string, value: string) => {
    localStorage.setItem(key, value);
  };

  const setVideoTimeStamp = (timestamp: number) => {
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.VIDEO_TIMESTAMP,
      timestamp.toFixed(0)
    );
  };

  return {
    configures:
      (configures && (JSON.parse(configures) as ICommunity)) || undefined,
    screenSaver:
      (screenSaver && (JSON.parse(screenSaver) as IChannel)) || undefined,
    myPlace: (myPlace && (JSON.parse(myPlace) as IChannel)) || undefined,
    sessionId:
      localStorage.getItem(LOCAL_STORAGE_KEYS.SESSIONS_ID) || "no-session",
    timeStamp: localStorage.getItem(LOCAL_STORAGE_KEYS.VIDEO_TIMESTAMP) || "0",
    screenSaverTimeout: screenSaverTimeout
      ? Number(screenSaverTimeout) * 1000
      : 3 * 1000,
    radius: radius || undefined,
    storeConfigures,
    storeScreenSaver,
    storeMyPlace,
    storeLocalStorage,
    setVideoTimeStamp,
    deleteTimeStamp: () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.VIDEO_TIMESTAMP);
    },
  };
};

export default useLocalStorage;
